
    import { defineComponent } from 'vue'
    import XBreadcrumb from '../../components/Breadcrumb.vue';
    import validateVigencyService from '@/apps/shared/services/validateVigencyService-service ';
    import quotationService from '@/apps/shared/services/getAPWorkOccasion-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    export default defineComponent({
        components: {
            XBreadcrumb,
        },
        data() {
            return {
                vigencyStart: new Date(),
                vigencyStartLimit: new Date(),
                vigencyEnd: new Date(),
                vigencyEndLimit: null,
                vigencyStartToEndLimit: new Date(),
                vigencyIsValidated: true,
                peopleToCover: 1,
                peopleToCoverMax: 10,//revisar este dato
                selectedPaymentMethod: "1",
                showPaymentType: false,
                format: "DD/MM/YYYY",
                isBack: false,
                breadcrumItems: [
                    { text: 'Inicio', path: '/ocasion-de-trabajo' },
                    { text: 'Cotiza tu seguro de Accidentes personales', path: '/ocasion-de-trabajo/DatosVigencia' },
                ],
                TabOneWelcome: null,
                TabTwoData: null,
                dataThreeTabJson: null,
                backExit: false,
                referente: null,
                medium: null,
            }
        },

        methods: {

            validate() { 
                var validation =
                    NF.Validation.Form.validate('#formTabThree');
                return validation;
            },

            siguiente: function () {

                NF.UI.Page.block();

                var validate = this.validate();

                this.validateVigency().then(validateVigencyResponse => {
                    this.vigencyIsValidated = validateVigencyResponse.validityAllowed;
                });

                if (validate && this.vigencyIsValidated) {

                    sessionStorage.removeItem("vigencyStart");
                    sessionStorage.removeItem("vigencyEnd");
                    sessionStorage.removeItem("peopleToCover");
                    sessionStorage.removeItem("quotaQuantity");

                    sessionStorage.setItem("vigencyStart", JSON.stringify(this.vigencyStart));                
                    sessionStorage.setItem("vigencyEnd", JSON.stringify(this.vigencyEnd));
                    sessionStorage.setItem("peopleToCover", JSON.stringify(this.peopleToCover));
                    sessionStorage.setItem("quotaQuantity", JSON.stringify(this.selectedPaymentMethod)); 

                    if (this.backExit) {
                        sessionStorage.setItem("ExitOrContinueModal", "false");
                    }
                    else {
                        sessionStorage.setItem("ExitOrContinueModal", "true");
                    }

                    var quotationRequest = this.organizeFormData();

                    NF.UI.Page.block();

                    quotationService
                      .createNewOcassionOfWorkQuotation(quotationRequest)
                      .then(response => {
                        sessionStorage.removeItem("quotationData");
                        sessionStorage.setItem("quotationData", JSON.stringify(response));

                        NF.UI.Page.unblock();
                        this.$router.push({
                          name: 'ocassion-of-work-tab-four',
                        });
                      })
                      .catch((err: any) => {
                        NF.UI.Page.unblock();
                        NF.Notification.show({
                          type: NF.Notification.Type.ERROR,
                          title: "Error",
                          content: "Ocurrió un error al crear la cotización. Por favor intentá de nuevo más tarde.",
                          autoHideDelay: 7000
                        });
                        window.globalThis.dataLayer.push({
                          pas: null,
                          email: this.TabOneWelcome.email,
                          product: 'aptrabajo',
                          event: 'errorServidor',
                          paso: 'cotizador-aptrabajo-vigenciaypersonas',
                          referente: this.referente,
                          medio: this.medium
                        });
                      });
                }
                
            },

            organizeFormData() {
                const tabOne = {
                    name: this.TabOneWelcome.name,
                    lastName: this.TabOneWelcome.lastName,
                    areaCode: this.TabOneWelcome.areaCode,
                    telephone: this.TabOneWelcome.telephone,
                    email: this.TabOneWelcome.email,
                    cityId: parseInt(this.TabOneWelcome.selectedLocality.id),
                    zipCode: this.TabOneWelcome.selectedLocality.zipCode,
                };

                const tabTwo = {
                    profession: this.TabTwoData.selectedActivity.idActivity,
                    classification: this.TabTwoData.selectedActivity.idClassiffication,
                    task: this.TabTwoData.selectedActivity.idTask,
                    personType: this.TabTwoData.personType
                };
               
                const clientIdentify = {
                    fiscalConditionCode: this.TabTwoData.fiscalCondition,
                    documentNumberSpecified: false,
                    documentNumber: null,                
                };

                const formData = {
                    personType: tabTwo.personType,               
                    cityId: tabOne.cityId,
                    effectDate: this.vigencyStart,
                    expirationDate: this.vigencyEnd,
                    ivaConditionId: parseInt(this.TabTwoData.fiscalCondition),
                    paymentFrequencyId: parseInt(this.selectedPaymentMethod),
                    productId: this.TabTwoData.selectedActivity.productId,
                    zipCode: tabOne.zipCode,
                    profession: tabTwo.profession,
                    classification: tabTwo.classification,
                    task: tabTwo.task,                        
                    personsToCover: this.peopleToCover,
                    quotaQuantity: this.selectedPaymentMethod,
                };

                const requestPayload = {
                    ...formData,
                    clientIdentify: clientIdentify,
                };

                return  requestPayload;
            },


            validateVigency() {
                return new Promise<any>(async (resolve) => {
                    await validateVigencyService.validateVigency(this.vigencyStart, this.vigencyEnd, 555).then(validateVigencyResponse => {
                        this.vigencyIsValidated = validateVigencyResponse;
                        resolve(validateVigencyResponse);
                    });
                });
            },

            checkVigency() {
                var isVigencyThreeMonthsOrLonger = false;
                const startDate = new Date(this.vigencyStart);
                const endDate = new Date(this.vigencyEnd);
                const monthsDifference =
                    (endDate.getFullYear() - startDate.getFullYear()) * 12 +
                    (endDate.getMonth() - startDate.getMonth());
                if (monthsDifference >= 3) {
                    isVigencyThreeMonthsOrLonger = true
                }
                this.showPaymentType = isVigencyThreeMonthsOrLonger;
            },

            volver() {
                sessionStorage.setItem("ExitOrContinueModal", "false");
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'ocassion-of-work-tab-two',
                })
            },

            restPeopleToCover() {
                if (this.peopleToCover >= 2) {
                    this.peopleToCover--;
                }
            },

            addPeopleToCover() {
                this.peopleToCover++;
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultAPTrabajoGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            async pageCustomization() {
                const defaultTitle = 'Ocasión de Trabajo';
                const actualPath = '/ocasion-de-trabajo';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
        },

        watch: {
            vigencyStart(newVal) {
                const nextDay = new Date(newVal);
                nextDay.setDate(nextDay.getDate() + 1);

                this.vigencyStartToEndLimit = nextDay;

                if (this.vigencyEnd < nextDay) {
                    this.vigencyEnd = nextDay;
                }
               
                this.checkVigency();
            },

            vigencyEnd(newVal) {
                this.checkVigency();
            },
            peopleToCover(newVal, OldVal) {
                if (newVal > 10) {
                    this.peopleToCover = OldVal;
                }
            },
        },

        async mounted() {
            NF.UI.Page.block();

            const parallelPromises = [
                this.pageCustomization(),
                this.updateByProductGoogleAnalytics(),
            ];

            await Promise.all([
                ...parallelPromises,
            ]);

            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
            var medium = sessionStorage.getItem("Medium");
            medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

            const today = new Date()
            this.vigencyStartToEndLimit = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate() + 1
            );
            this.vigencyEnd = new Date(
                today.getFullYear(),
                today.getMonth() + 1,
                today.getDate()
            );         

            sessionStorage.setItem("ExitOrContinueModal", "true");
            var validBack = sessionStorage.getItem("pressBack");
            if (validBack) {
                sessionStorage.removeItem("pressBack");
                this.backExit = true;
            }
            else {
                this.isBack = false;
                this.backExit = false;
            }

            var TabOneWelcome = sessionStorage.getItem("TabOneWelcome");            
            if (TabOneWelcome != null) {
                this.TabOneWelcome = JSON.parse(TabOneWelcome!);                
            };

            var TabTwoData = sessionStorage.getItem("TabTwoData");
            if (TabTwoData != null) {
                this.TabTwoData = JSON.parse(TabTwoData!);               
            };

            var dataThreeTab = sessionStorage.getItem("dataThreeTab");            
            if (dataThreeTab != null) {
                this.dataThreeTabJson = JSON.parse(dataThreeTab!);

                NF.UI.Page.unblock();
            }
            else {
                NF.UI.Page.unblock();
            }
            window.globalThis.dataLayer.push({
                'pas': null,
                'email': this.TabOneWelcome.email,
                'product': 'aptrabajo',
                'event': 'cotizador-aptrabajo-vigenciaypersonas',
                'referente': this.referente,
                'medio': this.medium
            });
        },
    })
